import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
    Box,
} from "@material-ui/core";
import { REI_ADDR } from '../../abis/address'
import REITokenABI from '../../abis/REIToken.json'
import { ethers } from "ethers";
import { useWeb3Context } from "../../hooks/web3Context";
import { useMediaQuery } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";


const Landing = ({ account, setNotification, tokenInfo, projectInfo }) => {
    const [pending, setPending] = useState(false);
    const { connect, hasCachedProvider, provider, chainID, connected } = useWeb3Context();
    const sm = useMediaQuery("(max-width: 450px)");

    const onClaim = async () => {
        setPending(true);
        const tokenContract = new ethers.Contract(REI_ADDR, REITokenABI, provider.getSigner());
        try {
            const tx = await tokenContract.claim();
            await tx.wait();
        }
        catch (error) {
            console.log(error);
            setNotification({ type: 'error', title: 'Error', detail: error.message })
        }
        setPending(false);
    }

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return (
        <StyledContainer>
            <Box>
                <Box display={'flex'} justifyContent={'space-between'}>
                    <Panel width={'33%'} minWidth={'350px'} mr={'30px'}>
                        <Box fontFamily={'Montserrat'} fontSize={'36px'} fontWeight={'600'} textAlign={'center'} mt={'10px'}>Your Rewards</Box>
                        <Box width={'fit-content'} mx={'auto'} mt={'40px'}>
                            <img src={'/images/reward.png'} width={'230px'} />
                        </Box>
                        <ValuePanel mt={'30px'}>
                            <Box mr={'20px'} mt={'8px'}>
                                <img src={'/images/value.webp'} width={'48px'} />
                            </Box>
                            <Box>
                                <Box color={'rgb(45, 221, 77)'}>
                                    Balance
                                </Box>
                                <Box pt={'5px'} fontWeight={'600'} fontSize={'18px'}>
                                    {tokenInfo.balance === undefined ?
                                        <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                        :
                                        <Box>{numberWithCommas(parseFloat(tokenInfo.balance).toFixed(2))} REIT</Box>
                                    }
                                </Box>
                            </Box>
                        </ValuePanel>

                        <ValuePanel mt={'20px'}>
                            <Box mr={'20px'} mt={'8px'}>
                                <img src={'/images/value.webp'} width={'48px'} />
                            </Box>
                            <Box>
                                <Box color={'rgb(45, 221, 77)'}>

                                    Balance Price
                                </Box>
                                <Box pt={'5px'} fontWeight={'600'} fontSize={'18px'}>
                                    {tokenInfo.balance === undefined || projectInfo.price === undefined ?
                                        <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                        :
                                        <Box>${numberWithCommas(Number(tokenInfo.balance * projectInfo.price).toFixed(2))}</Box>
                                    }
                                </Box>
                            </Box>
                        </ValuePanel>
                        <ValuePanel mt={'20px'}>
                            <Box mr={'20px'} mt={'8px'}>
                                <img src={'/images/value.webp'} width={'48px'} />
                            </Box>
                            <Box>
                                <Box color={'rgb(45, 221, 77)'}>
                                    Pending Rewards
                                </Box>
                                <Box pt={'5px'} fontWeight={'600'} fontSize={'18px'}>
                                    {tokenInfo.pendingReward === undefined || projectInfo.ethPrice === undefined ?
                                        <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                        :
                                        <Box>${numberWithCommas(Number(tokenInfo.pendingReward * projectInfo.ethPrice).toFixed(2))}</Box>
                                    }
                                </Box>
                            </Box>
                        </ValuePanel>
                        <Box mt={'25px'} display={'flex'} justifyContent={'end'}>
                            <StyledButton disabled={pending || !connected} onClick={() => onClaim()}>
                                CLAIM
                            </StyledButton>
                        </Box>
                    </Panel>
                    <Box width={'63%'} >
                        <Panel fontSize={sm ? '16px' : '21px'} px={'35px'}>
                            <Box fontFamily={'Montserrat'} fontSize={'36px'} fontWeight={'600'} mt={'10px'}>Token Info</Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Name</Box>
                                <Box fontWeight={600}>REIToken</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Symbol</Box>
                                <Box fontWeight={600}>REIT</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Decimal</Box>
                                <Box fontWeight={600}>18</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Total Supply</Box>
                                <Box fontWeight={600}>{numberWithCommas(Number(tokenInfo.totalSupply))} REIT</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'} mb={'10px'}>
                                <Box>Price</Box>
                                <Box fontWeight={600}>${(Number(projectInfo.price || 0).toFixed(10))}</Box>
                            </Box>
                        </Panel>
                        <Panel mt={'20px'} fontSize={sm ? '16px' : '21px'} px={'35px'}>
                            <Box fontFamily={'Montserrat'} fontSize={'36px'} fontWeight={'600'} mt={'10px'}>Project Info</Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Market Cap</Box>
                                <Box fontWeight={600}>${numberWithCommas(Number(tokenInfo.totalSupply * projectInfo.price || 0).toFixed(2))}</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Holders</Box>
                                <Box fontWeight={600}>{Number(tokenInfo.holders || 0)}</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Daily Volume</Box>
                                <Box fontWeight={600}>${numberWithCommas(Number(projectInfo.volume * projectInfo.price || 0).toFixed(2))}</Box>
                            </Box>

                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'}>
                                <Box>Total Rewards</Box>
                                <Box fontWeight={600}>{numberWithCommas(Number(tokenInfo.totalReward || 0).toFixed(2))} ETH</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'15px'} mb={'10px'}>
                                <Box>Total Rewards Price</Box>
                                <Box fontWeight={600}>${numberWithCommas(Number(tokenInfo.totalReward * projectInfo.ethPrice || 0).toFixed(2))}</Box>
                            </Box>
                        </Panel>
                    </Box>
                </Box>
            </Box>
        </StyledContainer>
    );
};

const ValuePanel = styled(Box)`
    background-image : linear-gradient(106.91deg, #376fddd2 30.28%, #376fdd02 119.6%);
    display : flex;
    padding : 15px 20px;
    border-radius : 12px;
    align-items : center;
`;
const StyledContainer = styled(Box)`
  
  padding-top : 100px;
  background-image : url('/images/landing.png');
  min-height : 100vh;
  >div{
    max-width : 1100px;
    margin : 0 auto;
    padding : 0 10px;
  }
  padding-bottom : 140px;
  @media screen and (max-width : 850px){
      >div>div{
          flex-direction : column;
      }
      >div>div>div:nth-child(1){
          margin-bottom : 25px;
      }
      >div>div>div{
          min-width : unset;
          width : 100%;
          max-width : 500px;
          margin : 0 auto;
      }
  }
`;
const Panel = styled(Box)`
    border : 5px solid rgb(55, 111, 221);
    border-radius : 20px;
    padding : 20px;
    color : white;
    backdrop-filter : blur(15px);
`;

const StyledButton = styled.button`
    padding : 13px 48px;
    font-weight : bold;
    font-size : 16px;
    border-radius : 2em;
    cursor : pointer;
    transition : all 0.3s;
    display : flex;
    justify-content : center;
    align-items : center;
    background-color : transparent;
    :hover{
        background-color : #2ddd4d;
    }
    :disabled{
        color : rgb(200,200,200);
        border : 3px solid #2ddd4db2;
        cursor : not-allowed;
        background-color : rgba(0,0,0,0.1);
    }
    border : 3px solid #2ddd4d;
    color : white;
    font-family : 'Open Sans';
    backdrop-filter : blur(10px);
`;
export default Landing;
